import { Icon, IconSize } from '@shipengine/giger';
import { getTrackingStatusIconName } from '../../../utils/TrackingStatus.js';
import { getParcelTrackingStatusIconStyles } from './ParcelTrackingStatusIconStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function ParcelTrackingStatusIcon(_ref) {
  let {
    status,
    ...otherProps
  } = _ref;
  return jsx(Icon, {
    css: getParcelTrackingStatusIconStyles(status),
    size: IconSize.SIZE_SMALL,
    name: getTrackingStatusIconName(status),
    ...otherProps
  });
}

export { ParcelTrackingStatusIcon };
//# sourceMappingURL=ParcelTrackingStatusIcon.js.map
